import React, { useState } from "react";
import PatternOption from "./PatternOption";
import { useFormikContext } from "formik";
import get from "lodash/get";
import MultiSelect from "components/Form/fields/MultiSelect";
import { PATTERN_OPTIONS } from "utils/constants/fields";
import Toggle from "react-toggle";
import { getToggleProps } from "utils/form";

const DEFAULT_LABEL = "Validate";
const DEFAULT_DESCRIPTION = "Value must match this format.";

const PatternSelect = ({
  name,
  label = DEFAULT_LABEL,
  description = DEFAULT_DESCRIPTION
}) => {
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();

  const pattern = get(values, name);
  const patternTouched = Boolean(get(name, touched));
  const [active, setActive] = useState(Boolean(pattern));

  const selected = PATTERN_OPTIONS.find((option) => option.pattern === pattern);

  let selections = [];
  if (selected) {
    selections = [
      {
        id: selected.pattern,
        name: selected.label
      }
    ];
  }

  const selectProps = {
    value: selections,
    placeholder: "Select pattern",
    options: PATTERN_OPTIONS,
    onChange: () => ({ value, source, testId }) => {
      setFieldValue(name, value);

      if (!patternTouched) {
        setFieldTouched(name, true);
      }
    },
    isMulti: false,
    labelTransform: (value) => value,
    components: {
      Option: PatternOption
    }
  };

  return (
    <div className="w-100 flex flex-column">
      <div className="w-100 flex flex-row justify-between items-center">
        <label className="f6 dib fw6">{label}</label>
        <Toggle
          {...getToggleProps({
            active,
            setFieldValue: (_, active) => {
              setActive(active);
              if (active && !pattern) {
                setFieldValue(name, PATTERN_OPTIONS[0].pattern);
              } else if (!active && pattern) {
                setFieldValue(name, "");
              }
              if (!patternTouched) {
                setFieldTouched(name, true);
              }
            }
          })}
        />
      </div>
      <div className="f6 pt2">{description}</div>
      <div className="pt3">
        <MultiSelect {...selectProps} />
      </div>
    </div>
  );
};

export default PatternSelect;
